import {
    PROMO_NOTIFICATION_EVENT,
    type PromoNotificationPayload,
} from "@/context/PromoNotificationContext";

export const showPromoNotification = (payload: PromoNotificationPayload) => {
    if (typeof window === "undefined") return;

    window.dispatchEvent(
        new CustomEvent<PromoNotificationPayload>(PROMO_NOTIFICATION_EVENT, {
            detail: payload,
        })
    );
};

export const showFreeVotesNotification = (
    votes: number,
    actionHref = "/home",
    id = `free-votes-${votes}`,
    options: { graphicalDisplay?: boolean; imageUrl?: string } = {}
) => {
    const graphicalDisplay = options.graphicalDisplay ?? true;
    const imageUrl = options.imageUrl?.trim();

    showPromoNotification({
        id,
        variant: "votes",
        eyebrow: "Free votes",
        title: `${votes} free votes added`,
        message: "We added free votes to your account. They're available in your balance for voting.",
        rewardLabel: `+${votes} votes`,
        rewardAmount: votes,
        graphicalReward: graphicalDisplay,
        imageUrl,
        actionLabel: undefined,
        actionHref: undefined,
        showOnce: true,
    });
};
